import {
  calculateColumnWidth,
  mapColumnTypes,
  TYPES,
} from "@/react/components/table/columns";
import {
  licenseSchema,
  licenseStatusMap,
} from "@/react/features/smp/licenses/schema";
import { getColumnDef } from "@/react/schema/schemaFields";
import selectColumnFactory from "@/react/components/table/components/selectColumnFactory";
import { LicensePoolUsage } from "@/react/features/smp/licenses/components/LicensePoolUsage";
import { addressSelectorCellFactory } from "@/react/features/smp/address-management/addressSelectorCellFactory";
import { addressSelectorColumnSetterFactory } from "@/react/features/smp/address-management/addressSelectorColumnSetterFactory";

export const licenseColumnDefinition = () =>
  calculateColumnWidth(
    [
      selectColumnFactory(),
      {
        ...getColumnDef(licenseSchema.fields.licenseId, "License"),
        type: TYPES.ID,
        sticky: true,
        size: 130,
      },
      {
        ...getColumnDef(
          licenseSchema.fields.licensePool.fields.licensePoolId,
          "License Pool"
        ),
        defaultHidden: true,
        size: 130,
      },
      {
        ...getColumnDef(licenseSchema.fields.licensePool.fields.skuId, "SKU"),
        customCell: ({ getValue }) => <strong>{getValue()}</strong>,
        sticky: true,
        size: 100,
      },
      {
        ...getColumnDef(licenseSchema.fields.licensePool.fields.name, "Name"),
        size: 400,
      },
      {
        ...getColumnDef(
          licenseSchema.fields.licensePool.fields.description,
          "Description"
        ),
        size: 400,
        defaultHidden: true,
      },
      {
        ...getColumnDef(
          licenseSchema.fields.licensePool.fields.serviceCountry,
          "Country"
        ),
      },
      {
        ...getColumnDef(licenseSchema.fields.status, "Status"),
        type: TYPES.SELECT,
        defaultDisplayFilter: {
          filterFnId: "is",
          value: "PENDING_CONFIGURATION",
        },
        options: licenseStatusMap,
        size: 200,
      },
      {
        ...getColumnDef(licenseSchema.fields.referenceId, "Reference"),
        defaultHidden: true,
        size: 200,
      },
      {
        ...getColumnDef(licenseSchema.fields.isSuspended, "Is Suspended"),
        type: TYPES.BOOLEAN,
        size: 100,
      },
      {
        ...getColumnDef(licenseSchema.fields.priority, "Priority"),
        type: TYPES.NUMBER,
        defaultHidden: true,
        size: 30,
      },
      {
        ...getColumnDef(
          licenseSchema.fields.licensePool.fields.unlimited,
          "Unlimited"
        ),
        type: TYPES.BOOLEAN,
        defaultHidden: true,
      },
      {
        id: "usage",
        header: "Unassigned / Total",
        tooltip: "Unassigned / Total",
        accessorFn: (license) => license.licensePool,
        customCell: ({ getValue }) => (
          <LicensePoolUsage licensePool={getValue()} />
        ),
        disableCopy: true,
        size: 200,
        enableDownload: false,
        enableSorting: false,
        enableColumnFilter: false,
      },
      {
        ...getColumnDef(licenseSchema.fields.serviceAddress, "Address"),
        editableCell: addressSelectorCellFactory(
          licenseSchema.fields.serviceAddressId.spec.key
        ),
        columnSetter: addressSelectorColumnSetterFactory(
          licenseSchema.fields.serviceAddressId.spec.key
        ),
        type: TYPES.STRING,
        editable: true,
        size: 400,
        enableDownload: true,
      },
      {
        ...getColumnDef(licenseSchema.fields.serviceAddressId, "Address ID"),
        type: TYPES.ID,
      },
      {
        ...getColumnDef(licenseSchema.fields.user.fields.loginId, "Username"),
        type: TYPES.ID,
        size: 200,
      },
    ].map(mapColumnTypes)
  );
